import { InfoCircleOutlined } from "@ant-design/icons";
import { Col, Form, Row, Select, DatePicker, Input } from "antd";
import { httpService } from "../../../../../services/httpService.service";
import { useEffect, useState } from "react";

const { Option } = Select;

const Logistics = () => {
  const [coordinators, setCoordinators] = useState([]);

  const getCoordinators = (role) => {
    httpService.get(
      `/api/User/getAllusers?RoleIds=${role?.id}`,
      (res) => {
        console.log("RES", res?.data);
        setCoordinators(res?.data);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getRoles = () => {
    httpService.get(
      `/api/Account/getAllRoles`,
      (res) => {
        getCoordinators(
          res?.data?.find((e) => e?.roleName === "Field Coordinator")
        );
      },
      (err) => {
        console.log(err);
      }
    );
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div>
      <Row gutter={16}>
        <Col span={16}>
          <Form.Item
            label="TPM Coordinator"
            name="tpmCoordinator"
            rules={[
              { required: true, message: "Please select a TPM coordinator" },
            ]}
          >
            <Select placeholder="Enter TPM coordinator">
              {coordinators?.map((el) => (
                <Option value={el?.id}>
                  {el?.userDetails?.firstName
                    ? el?.userDetails?.firstName +
                      " " +
                      el?.userDetails?.lastName
                    : el?.userName}
                </Option>
              ))}
              {/* More options can be added here */}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Coordination Type"
            name="coordinationType"
            rules={[
              {
                required: true,
                message: "Please select a coordination type",
              },
            ]}
          >
            <Select
              placeholder="Select coordination type"
              options={[
                { value: 1, label: "Remote" },
                { value: 2, label: "In-person" },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Data Platform Account"
            name="fulcrumAccount"
            rules={[
              { required: true, message: "Please enter Data Platform Account" },
            ]}
          >
            <Input placeholder="Enter Data Platform Account" />
          </Form.Item>
        </Col>
        {/* <Col span={12}>
          <Form.Item
            label="Activation Date"
            name="activationDate"
            rules={[
              { required: true, message: "Please select an activation date" },
            ]}
          >
            <DatePicker style={{ width: "100%" }} onChange={(e) => changeValue(e)} />
          </Form.Item>
        </Col> */}
      </Row>
    </div>
  );
};
export default Logistics;
